module.exports = __webpack_public_path__ + "media/assets/pngs/slackIcon-61624401a484572061399979264607e7.png";